import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  getUserLastVerificationStatus,
  getValidUserTokens,
} from '@homeplay/api';
import { selectTokens, SiteContext } from '@homeplay/app';

export const useLastVerificationStatus = (isEnabled = true) => {
  const { siteName, isTouchUnit } = useContext(SiteContext);
  const userTokens = useSelector(selectTokens);
  const [lastVerificationInfo, setLastVerificationInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isEnabled || !userTokens) {
      setIsLoading(false);
      return;
    }

    let isActive = true;

    const getLastVerificationStatus = async () => {
      setIsLoading(true);

      try {
        const tokens = await getValidUserTokens(
          userTokens,
          siteName,
          isTouchUnit
        );
        const data = await getUserLastVerificationStatus(tokens.access.token);

        if (isActive) {
          setLastVerificationInfo(data);
        }
      } catch (reason) {
        // NOTE: an empty history is a valid case for a user who has never been verified
        if (
          isActive &&
          reason.response?.data?.error?.code !==
            'users_ctx:kyc:verification_history:empty'
        ) {
          setError(reason);
        }
      } finally {
        if (isActive) {
          setIsLoading(false);
        }
      }
    };

    getLastVerificationStatus();

    return () => {
      isActive = false;
    };
  }, [userTokens, isEnabled, siteName, isTouchUnit]);

  return {
    lastVerificationInfo,
    isVerificationPending:
      lastVerificationInfo?.verification_status === 'pending',
    isLoading,
    error,
  };
};
